import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { AuthProvider } from "./component/authentication/auth";
import { Route, Routes } from "react-router-dom";
import { RequireAuth } from "./component/authentication/requireAuth";
import Sidebar from "./component/siderbar/Sidebar";
import PageNotFound from "./component/404/PageNotFound";

import LoginScreen from "./screen/Login/LoginScreen";
import DashboardScreen from "./screen/Dashboard/DashboardScreen";
import StaffListScreen from "./screen/Staff/StaffListScreen";
import AddStaffScreen from "./screen/Staff/AddStaffScreen";
import EditStaffScreen from "./screen/Staff/EditStaffScreen";
import ParentListScreen from "./screen/Parents/ParentListScreen";
import AddParentScreen from "./screen/Parents/AddParentScreen";
import EditParentScreen from "./screen/Parents/EditParentScreen";
import StudentListScreen from "./screen/Students/StudentListScreen";
import AddStudentScreen from "./screen/Students/AddStudentScreen";
import EditStudentScreen from "./screen/Students/EditStudentScreen";
import BatchListScreen from "./screen/Batch/BatchListScreen";
import AddBatchScreen from "./screen/Batch/AddBatchScreen";
import EditBatchScreen from "./screen/Batch/EditBatchScreen";
import InvoiceListScreen from "./screen/Invoice/InvoiceListScreen";
import ReceiptListNewScreen from "./screen/Receipt/ReceiptListNewScreen";
import AnnouncementListScreen from "./screen/Announcement/AnnouncementListScreen";
import AddAnnouncementScreen from "./screen/Announcement/AddAnnouncementScreen";
import EditAnnouncementScreen from "./screen/Announcement/EditAnnouncementScreen";
import CourseListScreen from "./screen/Class/CourseListScreen";
import AddCourseScreen from "./screen/Class/AddCourseScreen";
import EditCourseScreen from "./screen/Class/EditCourseScreen";
import CourseStudentListScreen from "./screen/Class/CourseStudentListScreen";
import ImportScreen from "./screen/Developer/ImportCSVScreen";
import Webpage from "./screen/Website/WebPage";
import TestDashboard from "./screen/Dashboard/TestDasboard";
import TutorAttendanceList from "./screen/Attendance/TutorAttendanceList";
import TutorAttendanceDetails from "./screen/Attendance/TutorAttendanceDetails";
import ExamPreview from "./screen/Exam/ExamPreview";
import ExamTemp from "./screen/Exam/ExamTemp";
import ExamSlip from "./screen/Exam/ExamSlip";
import Exam from "./screen/Exam/ExamScreen";
import ExamMissingStudent from "./screen/Exam/ExamMissingStudentScreen";
import RegisterScreen from "./screen/Register/RegisterScreen";
import RegisterListScreen from "./screen/Register/RegisterListScreen";
import LeaveScreen from "./screen/Leave/LeaveScreen";

function App() {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <CssBaseline />
          <div className="app">
            <Routes>
              <Route element={<Sidebar />}>
                <Route path="/Portal" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><DashboardScreen /></RequireAuth>} />
                <Route path="/Portal/Import" element={<RequireAuth access={["IT"]}><ImportScreen /></RequireAuth>} />
                <Route path="/Portal/Staff" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><StaffListScreen /></RequireAuth>} />
                <Route path="/Portal/Staff/Register" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><AddStaffScreen /></RequireAuth>} />
                <Route path="/Portal/Staff/EditStaff/:id" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><EditStaffScreen /></RequireAuth>} />
                <Route path="/Portal/Parent" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><ParentListScreen /></RequireAuth>} />
                <Route path="/Portal/Parent/Register" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><AddParentScreen /></RequireAuth>} />
                <Route path="/Portal/Parent/EditParent/:id" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><EditParentScreen /></RequireAuth>} />
                <Route path="/Portal/Students" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><StudentListScreen /></RequireAuth>} />
                <Route path="/Portal/Students/AddStudent" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><AddStudentScreen /></RequireAuth>} />
                <Route path="/Portal/Students/EditStudent/:id" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><EditStudentScreen /></RequireAuth>} />
                <Route path="/Portal/Class" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><CourseListScreen /></RequireAuth>} />
                <Route path="/Portal/Class/AddClass" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><AddCourseScreen /></RequireAuth>} />
                <Route path="/Portal/Class/EditClass/:id" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><EditCourseScreen /></RequireAuth>} />
                <Route path="/Portal/Class/StudentList/:id/:classname" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><CourseStudentListScreen /></RequireAuth>} />
                <Route path="/Portal/Batch" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><BatchListScreen /></RequireAuth>} />
                <Route path="/Portal/Batch/CreateBatch" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><AddBatchScreen /></RequireAuth>} />
                <Route path="/Portal/Batch/EditBatch/:id" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><EditBatchScreen /></RequireAuth>} />
                <Route path="/Portal/Invoice" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><InvoiceListScreen /></RequireAuth>} />
                <Route path="/Portal/Receipt" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><ReceiptListNewScreen /></RequireAuth>} />
                <Route path="/Portal/StaffLeave" element={<RequireAuth access={["IT", "Admin"]}><LeaveScreen /></RequireAuth>} />
                <Route path="/Portal/Announcement" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><AnnouncementListScreen /></RequireAuth>} />
                <Route path="/Portal/Announcement/CreateAnnouncement" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><AddAnnouncementScreen /></RequireAuth>} />
                <Route path="/Portal/Announcement/EditAnnouncement/:id" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><EditAnnouncementScreen /></RequireAuth>} />
                <Route path="/Portal/TutorAttendance" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><TutorAttendanceList /></RequireAuth>} />
                <Route path="/Portal/TutorAttendanceDetails/:id" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><TutorAttendanceDetails /></RequireAuth>} />
                <Route path="/Portal/ExamTemp" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><ExamTemp /></RequireAuth>} />
                <Route path="/Portal/Exam" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><Exam /></RequireAuth>} />
                <Route path="/Portal/ExamPreview" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><ExamPreview /></RequireAuth>} />
                <Route path="/Portal/ExamSlip" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><ExamSlip /></RequireAuth>} />
                <Route path="/Portal/ExamMissingStudent" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><ExamMissingStudent /></RequireAuth>} />
                <Route path="/Portal/Register" element={<RequireAuth access={["IT", "Admin", "Tutor"]}><RegisterListScreen /></RequireAuth>} />
              </Route>
              <Route path="/" element={<Webpage />} />
              <Route path="/Portal/Login" element={<LoginScreen />} />
              <Route path="/Register" element={<RegisterScreen />} />
              <Route path="*" element={<PageNotFound />} />
              <Route path="/test" element={<TestDashboard />} />
            </Routes>
          </div>
        </AuthProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
